import { StatItem } from "./StatItem";
import { useStatsBarSectionList } from "./useStatsBarSectionList";

const StatsBarSection = () => {
  const items = useStatsBarSectionList();

  return (
    <section className="ps-container-lg-margin ps-container-fixed tw-bg-purple-700 tw-w-full tw-py-40">
      <div className="ps-row tw-w-full">
        <div className="col-xs-12 tw-w-full tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-y-40 tw-gap-x-36 lg:tw-gap-x-32 md:tw-gap-y-0">
          {items.map(
            ({ id: statsBarItemId, statsBarItemValue, statsBarItemLabel }) => (
              <StatItem
                key={statsBarItemId}
                label={statsBarItemLabel}
                value={statsBarItemValue}
              />
            ),
          )}
        </div>
      </div>
    </section>
  );
};

export { StatsBarSection };
